/**
 * Google Maps
 * Author: Kyle Shearer
 */

var Map = (function () {

    var options = {
        map: $('.js-google-map')
    };

    function canInit() {

        if (options.map.length) {
            return true;
        }

        return false;
    }

    function init(params) {
        options = $.extend({}, options, params);

        if (canInit()) {
            initMap();
            console.log('Google Maps initialized');
        }
    }

    /**
     * Draw the google map
     */
    function drawMap(geocodedAddress) {

        if (geocodedAddress === false || geocodedAddress == null) {
            return;
        }

        var mapStyle = '';
        var mapOptions = {
            zoom: 15,
            center: new google.maps.LatLng(geocodedAddress.lat(), geocodedAddress.lng()),
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyle
        }

        map = new google.maps.Map(document.getElementById('google-map'), mapOptions);

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(geocodedAddress.lat(), geocodedAddress.lng()),
            map: map
        });
        
    }

    /**
     * Make a call to google geocoder and call drawMap if successful
     */
    function initMap() {

        geocoder = new google.maps.Geocoder();

        geocoder.geocode({
            'address': options.map.attr('data-address')
        }, function (results, status) {
            if (status == 'OK') {
                drawMap(results[0].geometry.location);
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
                return false;
            }
        });

        return;
    }

    return {
        init: init
    };

})();

$(function () {
    'use strict';
    Map.init();
});